var _path, _path2, _path3, _path4, _rect, _rect2, _g, _g2, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRapportLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 74,
    viewBox: "0 0 43 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0861 15.9697H2.46788C1.63804 15.9697 0.965332 16.6458 0.965332 17.4797V70.558C0.965332 71.3919 1.63804 72.068 2.46788 72.068H40.0861C40.916 72.068 41.5887 71.3919 41.5887 70.558V17.4797C41.5887 16.6458 40.916 15.9697 40.0861 15.9697Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0857 16.9395C40.3819 16.9395 40.6233 17.1821 40.6233 17.4797V70.557C40.6233 70.8546 40.3819 71.0972 40.0857 71.0972H2.46747C2.17133 71.0972 1.92985 70.8546 1.92985 70.557V17.4797C1.92985 17.1821 2.17133 16.9395 2.46747 16.9395H40.0857ZM40.0857 15H2.46747C1.10505 15 0 16.1105 0 17.4797V70.557C0 71.9262 1.10505 73.0367 2.46747 73.0367H40.0857C41.4481 73.0367 42.5532 71.9262 42.5532 70.557V17.4797C42.5532 16.1105 41.4481 15 40.0857 15Z",
    fill: "#252B41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.302246 26.3392V17.5248C0.302246 16.3004 1.294 15.3037 2.51234 15.3037H39.9964C41.2396 15.3037 42.2512 16.3204 42.2512 17.5697V26.3382H0.302246V26.3392Z",
    fill: "#252B41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51234 72.734C1.294 72.734 0.302246 71.7373 0.302246 70.5129V61.6985H42.2512V70.467C42.2512 71.7163 41.2396 72.733 39.9964 72.733H2.51234V72.734Z",
    fill: "#252B41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 18,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#FF8A03"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 65,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#FF8A03"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1157 2.08853C20.4429 1.00235 21.1759 -0.0457411 21.8537 0.0286538C22.5382 0.103139 23.0762 1.27276 23.2865 2.24208C23.7596 4.42631 22.654 5.95264 21.9521 9.67207C21.558 11.7565 21.4784 13.5284 21.4683 14.6123C21.4745 14.152 21.4707 13.4304 21.42 12.5546C21.0904 6.83286 19.3237 4.70639 20.1157 2.08853Z",
    fill: "#252B41"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_284_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.70807 5.46522C8.66696 5.01475 7.39322 4.89902 7.01296 5.46498C6.62845 6.03613 7.17533 7.20165 7.78051 7.98749C9.14469 9.75771 11.0242 9.89711 14.3194 11.7595C16.1667 12.8025 17.5722 13.8845 18.407 14.5758C18.0513 14.2837 17.5021 13.8154 16.8656 13.2118C12.7053 9.26981 12.2196 6.54823 9.70807 5.46522Z",
    fill: "#252B41"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.26 7.87619C35.9044 6.94262 36.2658 5.71573 35.7846 5.23263C35.2992 4.74435 34.0495 5.05402 33.161 5.49476C31.1592 6.48848 30.6568 8.30498 28.1889 11.1749C26.8064 12.7839 25.4717 13.9521 24.6311 14.6365C24.9869 14.3443 25.553 13.8968 26.2689 13.3899C30.945 10.076 33.7091 10.129 35.26 7.87619Z",
    fill: "#252B41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.48511,
    height: 14.5908,
    fill: "white",
    transform: "translate(23.25 14.6362) rotate(-179.232)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_284_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.48511,
    height: 14.5908,
    fill: "white",
    transform: "matrix(0.634617 -0.772827 -0.772827 -0.634617 17.2764 15.953)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRapportLogo);
export default __webpack_public_path__ + "static/media/rapportLogo.bb91f07664dd87d2c0e781d231427cd5.svg";
export { ForwardRef as ReactComponent };